import React from "react";
import ScrollToBehaviour from "../../behaviours/scroll-to-behaviour";

export default class Pagination extends React.Component<> {
    constructor(props){
        super(props);

        this.scrollToo = new ScrollToBehaviour();
        this.state = {
            totalPages: this.props.totalPages,
            pagesToShow: this.props.pagesToShow > this.props.totalPages ?  this.props.totalPages : this.props.pagesToShow,
            currentPage: this.props.currentPage
        };
    }

    componentWillReceiveProps(nextProps){
        if(this.state.totalPages !== nextProps.totalPages) this.setState({totalPages:parseInt(nextProps.totalPages)});
        if(this.state.pagesToShow !== nextProps.pagesToShow) this.setState({pagesToShow:parseInt(nextProps.pagesToShow) > parseInt(nextProps.totalPages) ? parseInt(nextProps.totalPages) : parseInt(nextProps.pagesToShow) });
        if(this.state.currentPage !== nextProps.currentPage) this.setState({currentPage:parseInt(nextProps.currentPage)});
    }

    onClickItem = (page) => {
        if (!this.props.disableScrollTop) window.scrollTo(0, 0);
        this.props.onChange(page);
    };

    displayPageNumber = (page, className) => {
        if (this.props.lastPageIcon && className === 'last') return <i className={this.props.lastPageIcon}></i>;
        if (this.props.firstPageIcon && className === 'first') return <i className={this.props.firstPageIcon}></i>;

        return page;
    }

    renderItem = (className, page) => (
        <div key={page + className} onClick={ () => this.onClickItem(page) } className={`pagination--page ${className}`}>
            <span>{this.displayPageNumber(page, className)}</span>
        </div>
    )

    renderPageLinks = () => {
        let buffer = (this.state.pagesToShow % 2 === 1 ? this.state.pagesToShow - 1 : this.state.pagesToShow) / 2;
        let startPage = this.state.currentPage - buffer;
        let pages = [];
        let pagesToShow = this.props.totalPages < this.state.pagesToShow ? this.props.totalPages : this.state.pagesToShow;

        if(startPage + this.state.pagesToShow > this.state.totalPages) startPage = this.state.totalPages - this.state.pagesToShow + 1;
        if(startPage <= 1) startPage = 1;
        
        for (let i = 0; i < pagesToShow; i++){
            let activeClass  = (startPage + i == this.state.currentPage) ? 'active' : '';
            pages.push( this.renderItem(activeClass,startPage + i));
        }

        return pages;
    };

    render(){
        let buffer = (this.state.pagesToShow % 2 === 1 ? this.state.pagesToShow - 1 : this.state.pagesToShow) / 2;
        if(this.state.totalPages <= 1) return  (<></>);
        return(
            <>{this.state.totalPages > 0 && <div className="pagination" >
                {this.state.currentPage > 1 && this.renderItem('prev', this.state.currentPage-1) }
                {this.state.currentPage > buffer + 1 && this.state.totalPages > 3 && this.renderItem('first', 1) }
                { this.renderPageLinks() }
                {this.state.currentPage < this.state.totalPages - buffer && this.state.totalPages > 3 && this.renderItem('last', this.state.totalPages) }
                {this.state.currentPage < this.state.totalPages && this.renderItem('next', this.state.currentPage+1) }
            </div>}</>
        );
    }
}